import { useEffect, useState } from "react";
import useGet from "../useGet";
import useCompanyBranches from "../useCompanyBranches";
import { MoneyCorpPermissions } from "../usePermissions/usePermissions";

const useCompany = (
  companyId: string | undefined,
  permissions: MoneyCorpPermissions,
  branchChangeCount: number,
  companyUpdateCount?: number
) => {
  const [company, setCompany] = useState<any>();
  const selectedCompanyReturn = useGet(
    `/api/Companies/${companyId}?ts=` + new Date().getTime(),
    "Unable to read company for id: '" + companyId + "'",
    null,
    [companyId, companyUpdateCount],
    undefined,
    () => companyId != null && companyId !== ""
  );

  const { companyBranches } = useCompanyBranches(companyId, permissions, [
    branchChangeCount
  ]);

  useEffect(() => {
    setCompany(
      selectedCompanyReturn.value && companyId
        ? { ...selectedCompanyReturn.value, branches: companyBranches }
        : null
    );
  }, [selectedCompanyReturn.value, companyId, companyBranches]);

  return {
    company,
    companyLoading: selectedCompanyReturn.loading
  };
};

export default useCompany;
